import { __rest as e } from "tslib";
import * as r from "react";
import a from "classnames";
import { ComponentClassNames as i } from "../shared/constants.js";
import "../Field/FieldClearButton.js";
import { FieldDescription as l } from "../Field/FieldDescription.js";
import { FieldErrorMessage as s } from "../Field/FieldErrorMessage.js";
import { Flex as o } from "../Flex/Flex.js";
import { Label as d } from "../Label/Label.js";
import { RadioGroupContext as t } from "./context.js";
import { useStableId as n } from "../utils/useStableId.js";
var m = r.forwardRef(function (m, c) {
  var u = m.children,
    p = m.className,
    b = m.defaultValue,
    f = m.descriptiveText,
    E = m.errorMessage,
    _m$hasError = m.hasError,
    F = _m$hasError === void 0 ? !1 : _m$hasError,
    h = m.id,
    v = m.isDisabled,
    R = m.isRequired,
    g = m.isReadOnly,
    j = m.label,
    _m$labelHidden = m.labelHidden,
    x = _m$labelHidden === void 0 ? !1 : _m$labelHidden,
    y = m.labelPosition,
    M = m.onChange,
    N = m.name,
    z = m.size,
    C = m.value,
    D = e(m, ["children", "className", "defaultValue", "descriptiveText", "errorMessage", "hasError", "id", "isDisabled", "isRequired", "isReadOnly", "label", "labelHidden", "labelPosition", "onChange", "name", "size", "value"]);
  var G = n(h),
    H = n(),
    O = n(),
    P = f ? O : void 0,
    V = r.useMemo(function () {
      return {
        currentValue: C,
        defaultValue: b,
        hasError: F,
        isRequired: R,
        isReadOnly: g,
        isGroupDisabled: v,
        onChange: M,
        size: z,
        name: N,
        labelPosition: y
      };
    }, [b, F, v, R, g, M, z, N, C, y]);
  return r.createElement(o, Object.assign({
    className: a(i.Field, i.RadioGroupField, p),
    "data-size": z,
    ref: c
  }, D), r.createElement(d, {
    id: H,
    visuallyHidden: x
  }, j), r.createElement(l, {
    id: O,
    labelHidden: x,
    descriptiveText: f
  }), r.createElement(o, {
    "aria-describedby": P,
    "aria-labelledby": H,
    className: i.RadioGroup,
    id: G,
    role: "radiogroup"
  }, r.createElement(t.Provider, {
    value: V
  }, u)), r.createElement(s, {
    hasError: F,
    errorMessage: E
  }));
});
m.displayName = "RadioGroupField";
export { m as RadioGroupField };